import api from "../services/api";


// Fetch all driver trips

export const fetchDriverTrips = async (page = 1, size = 10) => {
  try {
    const response = await api.get(
      "/driver-trip-management/all",
      {
        params: {
          page,
          size,
        },
      }
    );

    if (
      response.status === 200 &&
      response.data.success
    ) {
      return {
        success: true,
        data: response.data.data,
      };
    } else {
      console.warn(
        "Unexpected Response:",
        response
      );

      return {
        success: false,
        error: "Unexpected response from server",
      };
    }
  } catch (error) {
    console.error(
      "Error fetching driver trips:",
      error.message || error
    );

    return {
      success: false,
      error:
        error.message ||
        "Failed to fetch driver trips",
    };
  }
};


// Update driver trip

export const updateDriverTrip = async (
  tripId,
  payload
) => {
  try {
    const response = await api.put(
      `/driver-trip-management/${tripId}`,
      payload
    );

    if (
      response.status === 200 &&
      response.data.success
    ) {
      return {
        success: true,
        data: response.data.data,
      };
    } else {
      console.warn(
        "Unexpected Response:",
        response
      );

      return {
        success: false,
        error: "Unexpected response from server",
      };
    }
  } catch (error) {
    console.error(
      "Error updating driver trip:",
      error.message || error
    );

    return {
      success: false,
      error:
        error.message ||
        "Failed to update driver trip",
    };
  }
};


// Delete / cancel driver trip

export const deleteDriverTrip = async (
  tripId
) => {
  try {
    const response = await api.delete(
      `/driver-trip-management/${tripId}`
    );

    if (
      response.status === 200 &&
      response.data.success
    ) {
      return {
        success: true,
        data: response.data.data,
        message:
          response.data.message ||
          "Driver trip cancelled successfully",
      };
    } else {
      console.warn(
        "Unexpected Response:",
        response
      );

      return {
        success: false,
        error: "Unexpected response from server",
      };
    }
  } catch (error) {
    console.error(
      "Error deleting driver trip:",
      error.message || error
    );

    return {
      success: false,
      error:
        error.message ||
        "Failed to cancel driver trip",
    };
  }
};